import { Explorer } from '../types/Explorer';

export const explorer: Explorer = {
  fetching: true,
  failed: false,
  payload: {
    repositories: [],
    nodes: []
  }
};
